import { useEffect, useState } from "react"
import classnames from 'classnames';
import { mapKeys } from "lodash";

export function useProps({ ...props }, { ...defaultProps }) {
  return {
    ...props,
    ...defaultProps,
  }
}

export function useClassName({ default: defaultClassName = '', ...classNamesDefinition }, customClassNames = '', props = {}) {
  const [className, setClassName] = useState(defaultClassName)

  useEffect(() => {
    setClassName(`${defaultClassName} ${customClassNames}`)
  }, [customClassNames])

  const values = Object.values(props)
  const keys = Object.keys(props)

  useEffect(() => {

    if (keys.length) {
      const classNames = keys.reduce((classNames, key) => {
        classNames[classNamesDefinition[key]] = props[key] || false
        return classNames
      }, {})

      setClassName(`${defaultClassName} ${customClassNames} ${classnames(classNames)}`)
    }

  }, values)

  return className
}

export function useClassNames(className = '', { default: defaultClassName = '', ...classes }, props = {}) {
  const classNames = mapKeys(props, (_, key) => classes[key])
  return classnames(defaultClassName, classNames, className)
}